import client from '@/lib/feathers';
import CategoryMenu from '@/types/database/categoryMenu';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState: {
  serviceData: CategoryMenu;
  status: 'notLoaded' | 'loading' | 'loaded' | 'error';
} = {
  serviceData: {
    data: [],
    _id: '',
  },
  status: 'notLoaded',
};

export const fetchServicesThunk = createAsyncThunk(
  'service/fetchServicesThunk',
  async () => {
    try {
      const res = await client.service('categoryMenu').find({
        query: {
          service: 'serviceType',
        },
      });
      if (res.data.length > 0) {
        return res.data[0];
      }
    } catch (error) {
      console.error(error);
    }
  }
);

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchServicesThunk.fulfilled, (state, action) => {
      if (action.payload) {
        state.serviceData = action.payload;
        state.status = 'loaded';
      }
    });
  },
});

// export const {} = serviceSlice.actions;
export default serviceSlice.reducer;
